<template>
  <div>
    <section id="page-title" class="page-title-parallax page-title-dark page-title-right" 
      style="padding: 250px 0; 
        background-image: url('/assets/img/about.jpg'); 
        background-size: cover; 
        background-position: center center;" 
      data-stellar-background-ratio="0.2">

            <div class="container clearfix">
                <h1>INFINITY DANCE STUDIO</h1>
                <span>Since 2012</span>
            </div>

        </section>
    <section id="content">
    
    <div class="content-wrap">
        
        <div class="container clearfix">
            
            <div class="row clearfix">
                
                <div class="col-md-6">
                    
                    <h3>Our Mission</h3>
                    
                    <p>Is to provide each student the opportunity to learn and express themselves through the art of dance. We are committed to guide each of our dancers in a positive, structured, encouraging environment.</p>
                    
                    
                </div>
                
                <div class="col-md-6">
                    
                    <h3>About IDS</h3>
                    
                    <p>Infinity Dance Studio has been training, shaping and inspiring young dancers since it was established in 2012. Our studio offers the highest quality classes in a wide variety of dance styles to suit any and every dancer’s preference and level.</p>
                    <p>We, Infinity Dance Studio, understand the privilege that is is to participate in a community for the performing art of dance personifying the values of our foundation: professionalism, integrity, character, leadership, and commitment.</p>
                    
                </div>
                
            </div>
            
        </div>
        
      
        
    </div>
    
    
</section>
<section id="content">
            
                  
                   
               
                <div>
                    <div class="container clearfix">
                        <div class="row">
                            <div class="heading-block center topmargin-lg">
                                <h3>Meet Our Team</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Patricia Feldt" src="@/assets/img/Patricia Feldt.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Patricia Feldt</h4>
                                            <span>Studio Director</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Irasema Berreiro" src="@/assets/img/Irasema Cabrera.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Irasema Cabrera</h4>
                                            <span>Studio Manager</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Ana Valeira" src="@/assets/img/AnaValeria Blanco.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>AnaValeria Blanco</h4>
                                            <span>Manager Assistant</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Paula Barreiro" src="@/assets/img/Paula Barreiro.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Paula Barreiro</h4>
                                            <span>Company Coach and Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Ashley Mendez" src="@/assets/img/Ashley Mendez.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Ashley Mendez</h4>
                                            <span>Company Coach and Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Yadira Garcia" src="@/assets/img/Yadira Garcia.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Yadira Garcia</h4>
                                            <span>Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Claudia Miyar" src="@/assets/img/Claudia Miyar.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Claudia Miyar</h4>
                                            <span>Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Nicole Vazquez" src="@/assets/img/Nicole Vazquez.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Nicole Vazquez</h4>
                                            <span>Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Jenn Agrenot" src="@/assets/img/avatar.empty.jpg" width="360px" height="540px"/>
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Jenn Agrenot</h4>
                                            <span>Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-sm-8">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Gabriela Marques" src="@/assets/img/avatar.empty.jpg" width="360px" height="540px"/>
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            <h4>Gabriela Marques</h4>
                                            <span>Instructor</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>


<script>
  export default {
    name: "About",
    components:{

    }
  }
</script>
